import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

/**
 * This client is catching Dealer Actions
 * and calling Dealer Action Microservice to log actions in system database
 */
export default class AppActionsLogClient {
  static appActionsLogUrl = BASE_URL;

  static urlEncodeCommonId(user) {
    return user.commonId.split("|").join("%7C");
  }

  static recordEmailPhoneUpdatedAction(user, logPayload) {
    const url = `${this.appActionsLogUrl}/appActionLog/${this.urlEncodeCommonId(
      user
    )}/cust-facing/email-phone-updated`;

    return this.recordAppActionLog(url, logPayload);
  }

  static recordEmailNotificationToggle(user, logPayload) {
    const url = `${this.appActionsLogUrl}/appActionLog/${this.urlEncodeCommonId(
      user
    )}/emailNotificationToggle`;

    return this.recordAppActionLog(url, logPayload);
  }

  static recordEmployeePendingActionsEmailsToggle(user, logPayload) {
    const url = `${this.appActionsLogUrl}/appActionLog/${this.urlEncodeCommonId(
      user
    )}/employeePendingActionToggle`;

    return this.recordAppActionLog(url, logPayload);
  }

  static recordAddEmployee(user, logPayload) {
    const url = `${this.appActionsLogUrl}/appActionLog/${this.urlEncodeCommonId(
      user
    )}/employeeAdded`;

    return this.recordAppActionLog(url, logPayload);
  }

  static recordDeleteEmployee(user, logPayload) {
    const url = `${this.appActionsLogUrl}/appActionLog/${this.urlEncodeCommonId(
      user
    )}/employeeDeleted`;

    return this.recordAppActionLog(url, logPayload);
  }

  static recordParticipationStatus(user, logPayload) {
    const url = `${this.appActionsLogUrl}/appActionLog/${this.urlEncodeCommonId(
      user
    )}/toggle-membership`;

    return this.recordAppActionLog(url, logPayload);
  }

  static recordEditEmployee(user, logPayload) {
    const url = `${this.appActionsLogUrl}/appActionLog/${this.urlEncodeCommonId(
      user
    )}/recordEditEmployee`;

    return this.recordAppActionLog(url, logPayload);
  }

  static recordMerchantIdChange(user, logPayload) {
    const url = `${this.appActionsLogUrl}/appActionLog/${this.urlEncodeCommonId(
      user
    )}/recordMerchantIdChange`;

    return this.recordAppActionLog(url, logPayload);
  }

  static recordAppActionLog(url, logPayload) {
    return axios
      .put(url, logPayload, getHeaders())
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}
